/* eslint-disable @atlaskit/design-system/use-primitives-text */
/* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import {
	AUTHENTICATE_COMMAND,
	INSTALL_SKILLS_COMMAND,
	INSTRUCTION_1,
	VERIFY_INSTALLATION_COMMAND,
} from './constants';

const styles = cssMap({
	body: {
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		padding: '40px',
		margin: 0,
		font: token('font.body.large'),
		fontFamily: token('font.family.code'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		lineHeight: '24px',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		letterSpacing: '0.2px',
		whiteSpace: 'pre-wrap',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		color: '#6C6F77',
	},
	command: {
		display: 'block',
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		color: '#DDDEE1',
	},
});

const WINDOWS_INSTALL_COMMAND_1 = 'mkdir -Force "$env:LOCALAPPDATA\\Programs\\twg\\bin" | Out-Null';
const WINDOWS_INSTALL_COMMAND_2 =
	'New-Item -Path "$env:LOCALAPPDATA\\Programs\\twg\\bin\\twg.exe" -ItemType File -Force | Out-Null';

const WINDOWS_PATH_COMMAND = `Copy[Environment]::SetEnvironmentVariable("Path", "$([Environment]::GetEnvironmentVariable('Path', 'User'));$env:LOCALAPPDATA\\Programs\\twg\\bin", "User")'`;

export const WindowsTerminalBody = (): JSX.Element => (
	<pre css={styles.body}>
		{INSTRUCTION_1}
		{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
		<span css={styles.command}>{WINDOWS_INSTALL_COMMAND_1}</span>
		{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
		<span css={styles.command}>{WINDOWS_INSTALL_COMMAND_2}</span>
		{'\n'}# 2. Add to PATH, then restart PowerShell:
		{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
		<span css={styles.command}>{WINDOWS_PATH_COMMAND}</span>
		{'\n'}# 3. Verify the installation:
		{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
		<span css={styles.command}>{VERIFY_INSTALLATION_COMMAND}</span>
		{'\n'}# 4. Authenticate:
		{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
		<span css={styles.command}>{AUTHENTICATE_COMMAND}</span>
		{'\n'}# 5. Install skills:
		{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
		<span css={styles.command}>{INSTALL_SKILLS_COMMAND}</span>
	</pre>
);
